import i18n from "i18next";
import { initReactI18next } from "react-i18next";

// Import your translation files directly
import common from "./locales/en/common.json";
import createGame from "./locales/en/create-game.json";
import game from "./locales/en/game.json";
import gameSettings from "./locales/en/game-settings.json";
import main from "./locales/en/main.json";
import defaultTranslations from "./locales/en/default.json";

// don't want to use this?
// have a look at the Quick start guide
// for passing in lng and translations on init

const debug = import.meta.env.VITE_APP_I18N_DEBUG === "true";

i18n
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)

  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    resources: {
      en: {
        translation: defaultTranslations,
        common,
        "create-game": createGame,
        game,
        "game-settings": gameSettings,
        main,
      },
    },
    ns: [
      "translation",
      "common",
      "create-game",
      "game",
      "game-settings",
      "main",
    ],
    defaultNS: "translation",
    lng: "en",
    fallbackLng: "en",
    debug: debug,

    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
  });

export default i18n;
